import { Image } from '@/components/crRender'
import { Icon } from '@iconify/react'
import { useMemo } from 'react'
import medicalPlaceholder from '@/assets/images/placeholders/medical-placeholder.webp'

const ProviderCard = ({ requestDetails }) => {


    const logo = useMemo(() => requestDetails?.files?.findFirstValue('name', 'logo')?.['data']?.[0]?.name||"", [requestDetails])



    return (
        <div className="hospital-card">
            <div className="hospital-card-content">
                {/* @ts-ignore */}
                <Image src={`${window.WEB_LINK}${logo}`} className="hospital-card-image"  placeholder={medicalPlaceholder}/>
                <div className="hospital-card-details">
                    <div className="hospital-card-header">
                        <Icon icon="mdi:hospital-building" className="hospital-card-icon" />
                        <h2 className="hospital-card-name">{requestDetails?.providerName}</h2>
                    </div>

                    <div className="hospital-card-location">
                        <Icon icon="mdi:map-marker" />
                        <span>{requestDetails?.mainAddress}</span>
                    </div>

                    <div className="hospital-badges">
                        {requestDetails?.accredations?.mapWithKey((accreditation) => (
                            <span key={accreditation.key} className="hospital-badge">
                                {accreditation.value}
                            </span>
                        ))}
                    </div>

                    <p className="hospital-card-description">
                        {requestDetails?.profileSummary}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ProviderCard